import React, { useId } from 'react';
export const Grid = ({
  pattern,
  size
}: {
  pattern?: number[][];
  size?: number;
}) => {
  const p = pattern ?? [[Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1], [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1], [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1], [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1], [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1]];
  return <div className="pointer-events-none absolute left-1/2 top-0 -ml-20 -mt-2 h-full w-full [mask-image:linear-gradient(white,transparent)]" data-id="element-191">
      <div className="absolute inset-0 bg-gradient-to-r [mask-image:radial-gradient(farthest-side_at_top,white,transparent)] from-gray-900/30 to-gray-900/30 opacity-100" data-id="element-192">
        <GridPattern width={size ?? 20} height={size ?? 20} x="-12" y="4" squares={p} className="absolute inset-0 h-full w-full mix-blend-overlay fill-white/10 stroke-white/10" data-id="element-193" />
      </div>
    </div>;
};
export function GridPattern({
  width,
  height,
  x,
  y,
  squares,
  ...props
}: any) {
  const patternId = useId();
  return <svg aria-hidden="true" {...props} data-id="element-194">
      <defs data-id="element-195">
        <pattern id={patternId} width={width} height={height} patternUnits="userSpaceOnUse" x={x} y={y} data-id="element-196">
          <path d={`M.5 ${height}V.5H${width}`} fill="none" data-id="element-197" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" strokeWidth={0} fill={`url(#${patternId})`} data-id="element-198" />
      {squares && <svg x={x} y={y} className="overflow-visible" data-id="element-199">
          {squares.map(([x, y]: any) => <rect strokeWidth="0" key={`${x}-${y}`} width={width + 1} height={height + 1} x={x * width} y={y * height} data-id="element-200" />)}
        </svg>}
    </svg>;
}